// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"ef4020b8","453":"3d2dd6b9","667":"f5991eb0","977":"250b70b1"}[chunkId] + ".chunk.js";
};